import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';
import styles from './StatCard.module.scss';
import { useNavigate, useParams } from 'react-router-dom';

interface StatCardProps {
  cardId?: string;
  title: string;
  value: string;
  color: string;
  icon?: React.ReactNode;
  link?: string;
}

const StatCard: React.FC<StatCardProps> = ({cardId, title, value, color, icon, link }) => {
  const navigate = useNavigate();
  const { type } = useParams();
 
  const getForecastDate = () => {
    const date = new Date();
    date.setMonth(date.getMonth() + 1); // Move to next month
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
  };
  const forecasttype = 'forecastReports'
  const allreportstype = 'allReports'
  const userGrowthType = 'userGrowthReports'
  const redirectTo = () => {
    if(cardId === "studentstotal") {
      navigate('/scholarship-summary');
    } else if(cardId === "studentsactive") {
      navigate('/scholarship-summary?prefix=status&text=active');
    }else if(cardId === "applications") {
      navigate('/application-management?prefix=status&text=pending');
    } else if(cardId === "pending") {
      navigate('/application-management?prefix=status&text=scheduled_interview');
    } else if(cardId === "forecast") {
      navigate(`/scholarship-summary?prefix=next_due_installments&text=${getForecastDate()}`);
    } else if(cardId === "forecastReports") {
      navigate(`/management-reports/${forecasttype}`);
    } else if(cardId === "allReports") {
      navigate(`/management-reports/${allreportstype}`);
    } else if(cardId === "userGrowthReports") {
      navigate(`/management-reports/${userGrowthType}`);
    }
  }
  return (
    <Card className={styles.statCard}  onClick={redirectTo}>
      <CardContent className={`${styles.cardContent} ${(type === cardId) ? styles.active : ''} ${type === 'forecastReports' || type === 'allReports' || type === 'userGrowthReports' ? styles.reportCardItem : ''}`}>
        {icon && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: color,
            borderRadius: '50%',
            width: 36,
            height: 36,
          }}
        >
          {icon}
        </Box>
      )}
        <Box flex={1}>
          {title && (
          <Typography variant="subtitle2" className={`${styles.title} ${(type === cardId) ? styles.activeText : ''}`}>
            {title}
          </Typography>
          )}
          {value && (
        <Typography variant="h5" component="div" className={styles.value} >
          {value}
        </Typography>
        )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default StatCard;